import axios from 'axios';
import { AppRoutes } from 'modules/shop/routes';
import { SCAYLE_SHOP_ID } from 'src/envVariables';
import { errorWrapper } from '../../utils/network';
import {
  AuthApiUrls,
  AuthResponse,
  ICustomerForm,
  LoginCredentials,
} from './types';

export const login = (data: LoginCredentials) => {
  return errorWrapper(login.name, () =>
    axios.post<AuthResponse>(AuthApiUrls.LOGIN, {
      email: data.email,
      password: data.password,
      shop_id: SCAYLE_SHOP_ID,
    }),
  );
};

export const logout = () => {
  return errorWrapper(logout.name, () =>
    axios.post<AuthResponse>(AuthApiUrls.LOGOUT, {}),
  );
};

export const resetPasswordByEmail = (email: string) => {
  const { origin, pathname } = window.location;
  const locale = pathname.split('/')[1];

  return errorWrapper(resetPasswordByEmail.name, () =>
    axios.post<{ status: number }>(AuthApiUrls.RESET_PASSWORD, {
      shop_id: SCAYLE_SHOP_ID,
      email,
      reset_url: `${origin}/${locale}${
        AppRoutes.RESET_PASSWORD_CONFIRMATION
      }?hash={hash}`,
    }),
  );
};

export const updatePasswordByHash = (password: string, hash: string) => {
  return errorWrapper(updatePasswordByHash.name, () =>
    axios.put<{ status: number }>(AuthApiUrls.UPDATE_PASSWORD, {
      shop_id: SCAYLE_SHOP_ID,
      password,
      hash,
    }),
  );
};

export const register = (data: ICustomerForm) => {
  return errorWrapper(register.name, () =>
    axios.post<AuthResponse>(AuthApiUrls.REGISTER, {
      gender: data.gender,
      first_name: data.firstName,
      last_name: data.lastName,
      email: data.email.toLowerCase(), // fix EISREPL-609
      password: data.password,
      shop_id: SCAYLE_SHOP_ID,
    }),
  );
};

export const guestRegister = async ({
  firstName,
  lastName,
  email,
  gender,
}: {
  firstName: string;
  lastName: string;
  email: string;
  gender?: string;
}) => {
  return errorWrapper(guestRegister.name, () => {
    return axios.post<AuthResponse>(AuthApiUrls.LOGIN_GUEST, {
      first_name: firstName,
      last_name: lastName,
      email,
      gender,
      shop_id: SCAYLE_SHOP_ID,
    });
  });
};
